import { useSearch } from "@tanstack/react-router";
import { Button } from "antd";
import { useGetIntegrationQuery } from "api/TenantSlug/Integration/hooks.ts";
import { IntegrationTestForm } from "components/Forms/IntegrationTestForm/IntegrationTestForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";
import { getDrawerSearchParams } from "utils/drawerHelpers";

import { DrawerTitle } from "../../UI/DrawerTitle/DrawerTitle.tsx";

interface SearchParams {
    [`integrationTest-id`]: string;
}

export const IntegrationTestDrawer: FC = () => {
    const { t } = usePaldockTranslation("drawers.integration-test");
    const id = DrawerId.IntegrationTest;

    const searchParams = useSearch({ strict: false }) as SearchParams;
    const integrationId = searchParams[`${id}-id`];

    const getIntegrationQuery = useGetIntegrationQuery(
        integrationId,
        {},
        {
            enabled: !!integrationId,
        }
    );

    const integration = getIntegrationQuery.data?.integration;

    if (!integration) {
        return <></>;
    }

    return (
        <Drawer
            loading={getIntegrationQuery.isLoading}
            drawerId={id}
            title={<DrawerTitle mainTitle={integration.name} subTitles={[]} />}
            searchParamsToClean={getDrawerSearchParams(id, "id")}
            extraButtons={
                <Button size={"large"} htmlType="submit" type={"primary"} form={FormId.IntegrationTestForm}>
                    {t("actions.run_test")}
                </Button>
            }
        >
            <DrawerContent>
                <IntegrationTestForm integration={integration} />
            </DrawerContent>
        </Drawer>
    );
};
